module.exports = __webpack_public_path__ + "img/user-name.71d40229.svg";